export const formatQueryParams = (
  url: string,
  query?: Record<string, string | undefined | number | boolean>
) => {
  if (!query) return url;

  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value) {
      params.append(key, String(value));
    }
  });

  const queryString = params.toString();

  return queryString ? `${url}?${queryString}` : url;
};
